/* eslint-disable react/no-unused-class-component-methods */
import React from 'react';
import I18N from '@leverege/i18n';
import { capitalize } from '@leverege/string-util';
import { Config } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
import S from './Shared.css';
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.itemInfo.AbstractMissingRelationshipScreen');
class AbstractMissingRelationshipScreen extends React.Component {
  static CLIENT = 'MissingRelationshipScreen';
  constructor(props) {
    super(props);
    this.mobile = false;
    this.matchContext = {
      client: AbstractMissingRelationshipScreen.CLIENT,
      clientType: AbstractMissingRelationshipScreen.CLIENT,
      path: props.relationship.path,
      objectType: props.relationship.objectType,
      relationship: props.relationship,
      mobile: false
    };
    this.parentBlueprint = props.relationship.options.parentBlueprint;
    this.childBlueprint = props.relationship.options.blueprint;
    this.parentBlueprintName = t(`${this.parentBlueprint.model.name}BlueprintName`, this.parentBlueprint.model.name);
    this.childBlueprintName = t(`${this.childBlueprint.model.name}BlueprintName`, this.childBlueprint.model.name);
    this.parentItem = props.actions.parent().getItem(GlobalState.get());
  }
  getContext() {
    return {
      ...this.matchContext
    };
  }
  getName() {
    const {
      resourceId
    } = this.props;
    return capitalize(resourceId);
  }
  getIcon() {
    const {
      relationship: {
        attribute
      }
    } = this.props;
    return attribute.getIcon('screenIcon');
  }
  getTitle() {
    const titleFst = t('titleFst', 'This');
    const titleSnd = t('titleSnd', "Isn't Paired With a");
    const titleTrd = t('titleTrd', '');
    return [titleFst, this.parentBlueprintName, titleSnd, this.childBlueprintName, titleTrd].reduce((a, c) => c ? [...a, ' ', c] : a, []);
  }
  getSubtitle() {
    const subtitleFst = t('subtitleFst', 'Please pair');
    const subtitleSnd = t('subtitleSnd', 'to an existing');
    const subtitleTrd = t('subtitleTrd', '');
    return [subtitleFst, /*#__PURE__*/_jsxs("span", {
      className: S.bold,
      children: [this.parentBlueprintName, " ", this.parentItemDeviceId]
    }), subtitleSnd, this.childBlueprintName, subtitleTrd].reduce((a, c) => c ? [...a, ' ', c] : a, []);
  }
  getImageSource() {
    // Check relationship attribute metadata.
    const relAttr = this.parentBlueprint.attributes.find(attr => {
      return attr.model.type === 'relationship' && attr.model.relationshipType === 'oneToOne' && attr.model.targetBlueprintId === this.childBlueprint.id;
    });
    if (relAttr?.metadata?.icons?.noData) {
      return relAttr.metadata.icons.noData;
    }

    // Check child blueprint metadata.
    if (this.childBlueprint?.metadata?.icons?.noData) {
      return this.childBlueprint.metadata.icons.noData;
    }

    // Fallback.
    return Config.get('MissingRelationshipScreen', 'image', 'https://molten-ui-assets.storage.googleapis.com/missing-relationship.svg'); // eslint-disable-line max-len
  }
  render() {
    return null;
  }
}
export default AbstractMissingRelationshipScreen;